import React, {Fragment} from "react";
import PropTypes from "prop-types";
import "./ChatRoomMessage.css";
import moment from "moment";
import {AudioMessage} from "./AudioMessage/AudioMessage";
import {GenericMediaMessage} from "./GenericMediaMessage";
import {ImageMessage} from "./ImageMessage";
import {TextMessage} from "./TextMessage";
import {VideoMessage} from "./VideoMessage";
import {MessageContextMenu} from "./ContextMenu/MessageContextMenu";
import {FaSolidIcon} from "../../../FontAwesomeIcons";
import FuxEvents from "../../../../lib/FuxFramework/FuxEvents";
import {ReplyMessagePreview} from "../../../../launcher/Tabs/ChatTab/Helpdesk/ReplyMessagePreview";

export const EVT_CHAT_ROOM_HIGHLIGHT_MESSAGE = 'chat_room_message_highlight_message';

export class ChatRoomMessage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            contextMenu: {
                show: false,
                position: {top: 0, left: 0, right: 0}
            }
        }
        this.pressTimer = null;
    }

    componentDidMount() {
        FuxEvents.on(EVT_CHAT_ROOM_HIGHLIGHT_MESSAGE, this.highlightMessage);
    }

    componentWillUnmount() {
        FuxEvents.off(EVT_CHAT_ROOM_HIGHLIGHT_MESSAGE, this.highlightMessage);
    }

    highlightMessage = (id_messaggio) => {
        console.log(id_messaggio);
        if (this.props.messageData.id_messaggio == id_messaggio) {
            this.setState({isHighlighted: true}, _ => {
                setTimeout(_ => this.setState({isHighlighted: false}), 2000);
            });
        }
    }

    showMenu = (e) => {
        e.preventDefault();
        const rect = e.target.getBoundingClientRect();
        this.setState({
            contextMenu: {
                show: true,
                position: this.isMine() ?
                    {top: rect.bottom + window.scrollY, left: 'auto', right: 30} :
                    {top: rect.bottom + window.scrollY, left: rect.left, right: 'auto'}
            }
        }, _ => {
            setTimeout(_ => {
                document.addEventListener('click', this.handleContextMenuClose, true);
                window.addEventListener('scroll', this.handleContextMenuClose, true);
            }, 500)
        });
    }

    handleMouseDown = (e) => {
        if (this.props.messageContextMenuActions) {
            this.pressTimer = setTimeout(() => this.showMenu(e), 1000);
        }
    }

    handleMouseUp = () => {
        clearTimeout(this.pressTimer);
    }

    handleMouseLeave = () => {
        clearTimeout(this.pressTimer);
    }

    handleContextMenuClose = e => {
        if (e && e.target.closest('.message-context-menu')) return;
        this.setState({contextMenu: {...this.state.contextMenu, show: false}}, _ => {
            document.removeEventListener('click', this.handleContextMenuClose, true);
            window.removeEventListener('scroll', this.handleContextMenuClose, true);
        });
    }

    isMine = _ => parseInt(this.props.messageData.id_mittente) === parseInt(this.props.idSelf);

    getMessageComponent = ({type, metadata}) => {

        if (type === 'media') {
            const [mimeGenericType, mimeSpecificType] = metadata.mime_type.split('/');
            switch (mimeGenericType) {
                case 'image':
                    return ImageMessage;
                case 'audio':
                    return AudioMessage;
                case 'video':
                    return VideoMessage;
                default:
                    return GenericMediaMessage;
            }
        }

        switch (type) {
            case 'text':
            case 'auto':
                return TextMessage;
            default:
                return React.Fragment;
        }
    }

    handleReplayMessageClick = _ => {
        if (this.props.onGotoToReplyMessage) this.props.onGotoToReplyMessage(this.props.messageData.metadata.reply_message);
    }


    render() {
        const sendDate = moment(this.props.messageData.data_creazione).format('ddd D MMM');
        const isMine = this.isMine();
        const Message = this.getMessageComponent(this.props.messageData);

        const senderWithButton = (
            <div className={"d-flex align-items-center"}>
                {this.props.sender}
                {
                    this.props.messageContextMenuActions &&
                    <button className={"btn btn-sm btn-link p-0 ml-2"} onClick={this.showMenu}>
                        <FaSolidIcon name={"ellipsis-v"}/>
                    </button>
                }
            </div>
        );
        return (
            <Fragment>
                {
                    this.props.showOwnDate &&
                    <div className={"d-flex justify-content-center my-3"}>
                        <div className={"d-inline-block bg-white small px-2 py-1 text-capitalize rounded shadow-sm"}>
                            {sendDate}
                        </div>
                    </div>
                }
                <div onMouseDown={this.handleMouseDown} onMouseUp={this.handleMouseUp}
                     onMouseLeave={this.handleMouseLeave} data-message-id={this.props.messageData.id_messaggio}>
                    <div className={"d-flex " + (isMine ? 'justify-content-end mine' : 'yours')}>
                        <div
                            className={`message ${this.state.isHighlighted ? 'highlighted' : ''} ${this.props.isLast ? 'last' : ''}`}>
                            {
                                !!this.props.messageData.metadata?.reply_message &&
                                <ReplyMessagePreview
                                    idSelf={this.props.idSelf}
                                    message={this.props.messageData.metadata.reply_message}
                                    onClick={this.handleReplayMessageClick}
                                />
                            }
                            {!!senderWithButton && senderWithButton}
                            <Message
                                isMine={isMine}
                                messageData={this.props.messageData}
                                getMediaContentUrlAPI={this.props.getMediaContentUrlAPI}
                                getMediaContentPreviewUrlAPI={this.props.getMediaContentPreviewUrlAPI}
                                widget={this.props.widget}
                            />
                        </div>
                    </div>
                </div>
                {!!this.props.decorator && this.props.decorator}
                {
                    this.props.messageContextMenuActions &&
                    <MessageContextMenu
                        show={this.state.contextMenu.show}
                        position={this.state.contextMenu.position}
                        actions={this.props.messageContextMenuActions}
                        message={this.props.messageData}
                        onClose={this.handleContextMenuClose}
                    />
                }
            </Fragment>
        )
    }

}

ChatRoomMessage.propTypes = {
    messageData: PropTypes.object.isRequired,
    idSelf: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    isLast: PropTypes.bool.isRequired,
    showOwnDate: PropTypes.bool,
    getMediaContentUrlAPI: PropTypes.func.isRequired,
    getMediaContentPreviewUrlAPI: PropTypes.func.isRequired,
    messageContextMenuActions: PropTypes.array,
    onGotoToReplyMessage: PropTypes.func,
}

